<script lang="ts">
	import LearnHeader from '$lib/components/learn/LearnHeader.svelte';
	import { hatchStyle45 } from '$lib/styles/hatch';
</script>

<svelte:head>
	<title>Tutorials - Corral AI</title>
</svelte:head>

<div class="min-h-screen flex flex-col">
	<LearnHeader section="Tutorials" />

	<section
		class="bg-[#f9f9f4] py-24 relative flex-1 px-6 lg:px-12"
		style={hatchStyle45}
	>
		<div class="flex flex-col items-center text-center">
			<h1 class="font-display text-[48px] lg:text-[58px] text-black tracking-[-0.04em] leading-[1.1] mb-5">
				Tutorials
			</h1>
			<p class="font-body text-[16px] lg:text-[18px] text-[#5c5855] max-w-2xl">
				Step-by-step guides to help you get started with Corral AI.
			</p>
		</div>

		<div class="mt-16">
			<p class="text-[#878787] font-mono text-sm text-center py-12">
				Coming soon
			</p>
		</div>
	</section>
</div>
